import axios from "axios";
import { ProspectInterface } from "./prospect";

/**
 * Ensures all required fields are present in the payload, with defaults for missing values.
 * @param {ProspectInterface} obj - The object to sanitize.
 * @returns {Record<string, any>} - A sanitized object containing all non-optional fields.
 */
const sanitizePayload = (obj: ProspectInterface): Record<string, any> => {
  return {
    // Always include these fields with defaults for missing values
    CompanyName: obj.CompanyName ?? "",
    FirstName: obj.FirstName ?? "",
    LastName: obj.LastName ?? "",
    Phone: obj.Phone ?? "",
    Email: obj.Email ?? "",
    Address: obj.Address ?? "",
    City: obj.City ?? "",
    Province: obj.Province ?? "",
    PostalCode: obj.PostalCode ?? "",
    TitleDescription: obj.TitleDescription ?? "",
    SicCodeDescription: obj.SicCodeDescription ?? "",
    ConsultantId: obj.ConsultantId ?? "",
    ProspectStatus: obj.ProspectStatus ?? "",
    Website: obj.Website ?? "",
    ProspectComment: obj.ProspectComment ?? "",
    // Exclude Id, ProspectStatusId
  };
};

/**
 * Creates a new prospect using the backend API.
 * @param {ProspectInterface} payload - The new prospect data to send to the API.
 * @returns {Promise<any>} - Resolves with the API response when successful.
 */
const createProspect = async (payload: ProspectInterface): Promise<any> => {
    try {
      const sanitizedPayload = sanitizePayload(payload);
  
      console.log("DEBUG createProspect.ts: Sending sanitized payload to API:", JSON.stringify(sanitizedPayload));
  
      const { data } = await axios({
        method: "POST",
        url: `/api/cantrackv3/CreateProspect`,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        data: {payload: sanitizedPayload}, 
      });
  
      console.log("DEBUG createProspect.ts: Prospect created successfully:", data);
      return data;
    } catch (error) {
      console.error("DEBUG createProspect.ts: Error creating prospect:", error);
      throw error;
    }
  };
  

export default createProspect;
